import { Navigate, Outlet } from "react-router-dom";

interface AuthGuardProps {
  isAuthenticated: boolean;
  redirectPath?: string;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ isAuthenticated, redirectPath = "/login" }) => {
  return isAuthenticated ? <Outlet /> : <Navigate to={redirectPath} replace />;
};

export default AuthGuard;